import React from 'react'

import type { CampaignBannerHeaderContentBlock } from '@library/api-menu-experience'
import { CampaignBanner } from '@library/menu-page'
import type { RecipeUUID } from '@library/menu-service'

import { useMerchandisingBannerBasket } from 'routes/Menu/MenuExperience/hooks/useMerchandisingBannerBasket'
import { useSetBrowserCTAVisibility } from 'routes/Menu/domains/menu'
import { useRecipeTagsCwcWeb } from 'routes/Menu/hooks/useRecipeTagsCwcWeb'

import { useMenuExperienceCategoryNavigation } from '../menuExperienceNavigationContext'
import { useMenuExperienceRecipeDetails } from '../menuExperienceRecipeDetailContext'

type CampaignBannerContentBlockWrapperProps = {
  contentBlock: CampaignBannerHeaderContentBlock
}

export const CampaignBannerContentBlockWrapper = ({
  contentBlock,
}: CampaignBannerContentBlockWrapperProps) => {
  const { selectCategory } = useMenuExperienceCategoryNavigation()
  const { openRecipeDetail } = useMenuExperienceRecipeDetails()
  const isRecipeTagsCwcEnabled = useRecipeTagsCwcWeb()
  const { setBrowserCTAVisible } = useSetBrowserCTAVisibility()
  const { canAddRecipes, getRecipeCardState, onAddClick, onRemoveClick, reachedLimit } =
    useMerchandisingBannerBasket(contentBlock)

  const onCtaClick = (targetCategory: { id: string; slug: string }) => {
    selectCategory(targetCategory, 'merch_banner', undefined, {
      merch_header_type: contentBlock.type,
    })
  }

  const onRecipeClick = (recipeId: RecipeUUID) => {
    const recipe = contentBlock.items.find((item) => item.type === 'recipe' && item.id === recipeId)

    if (!recipe) {
      return
    }

    openRecipeDetail({
      recipeId,
      title: recipe.title,
      source: 'merch_banner',
      merchHeaderType: contentBlock.type,
    })
  }

  return (
    <CampaignBanner
      contentBlock={contentBlock}
      getRecipeCardState={getRecipeCardState}
      canAddRecipes={canAddRecipes}
      reachedLimit={reachedLimit}
      onAddClick={onAddClick}
      onBlockedAddAttempt={setBrowserCTAVisible}
      onCtaClick={onCtaClick}
      onRecipeClick={onRecipeClick}
      onRemoveClick={onRemoveClick}
      isRecipeTagsCwcEnabled={isRecipeTagsCwcEnabled}
    />
  )
}
